<template>
    <div class="shop-info">
        <div class="content-wrapper">
            <div class="tabs-wrapper" v-if="['info','address','refund-setting'].includes(curr_tab)">
                <div :class="['tab-item',{active:curr_tab == 'info'}]" @click="curr_tab='info'">店铺信息</div>
                <div :class="['tab-item',{active:curr_tab == 'address'}]" @click="curr_tab='address'">退货地址管理</div>
                <div :class="['tab-item',{active:curr_tab == 'refund-setting'}]" @click="curr_tab='refund-setting'">售后设置</div>
            </div>
            <template v-if="curr_tab == 'info'">
                <div class="info-wrapper">
                    <div class="info-top">
                        <div class="top-left">
                            <img :src="shopInfo.logo|default_img" alt="" class="shop-logo" />
                            <div class="shop-name-tag">
                                <div class="shop-name">{{shopInfo.shop_name}}</div>
                                <div class="shop-tag">{{shopInfo.label.join('|')}}</div>
                            </div>
                        </div>
                        <div class="top-right">
                            <div class="right-btn" @click="onShareClick">
                                <img src="@/assets/images/shop-manage/icon-shop-share.png" alt="" class="btn-icon" />分享店铺
                            </div>
                            <div class="right-btn" @click="$router.push({ name: 'ShopHome', query: { uid: userInfo.code } })">
                                <img src="@/assets/images/shop-manage/icon-shop-btn.png" alt="" class="btn-icon" />进入店铺
                            </div>
                            <div class="right-btn edit" @click="onShopInfoEdit">
                                编辑
                            </div>
                        </div>
                    </div>
                    <div class="info-desc">
                        <div class="label">店铺介绍:</div>
                        <div class="desc" v-html="shopInfo.shop_desc"></div>
                    </div>
                </div>
                <div class="part-title">店铺资质：</div>
                <div class="shop-type-part">
                    <div class="shop-type-item">
                        <div class="label">店铺类型：</div>
                        <div class="value">{{shopInfo.type == 1 ? '个人店铺' : '企业店铺'}}</div>
                    </div>
                    <div class="shop-type-item">
                        <div class="label">经营者证件类型：</div>
                        <div class="value">身份证</div>
                    </div>
                    <div class="shop-type-item">
                        <div class="label">开店时间：</div>
                        <div class="value">{{shopInfo.create_time | date_format}}</div>
                    </div>
                </div>
                <div class="shop-certificate-part">
                    <div class="part-item">
                        <div class="part-label">经营者身份证头像面:</div>
                        <img :src="idFront|default_img" alt="" class="part-value" />
                    </div>
                    <div class="part-item">
                        <div class="part-label">经营者身份证国徽面:</div>
                        <img :src="idBack|default_img" alt="" class="part-value" />
                    </div>
                    <div class="change-btn" v-if="false">变更主体</div>
                </div>
                <div class="part-title">提现账户：</div>
                <div class="card-info" id="card">
                    <div class="card-info-item">
                        <div class="card-info-label">开户银行：</div>
                        <div class="card-info-value">{{form_bank.card_bank || '-'}}</div>
                    </div>
                    <div class="card-info-item">
                        <div class="card-info-label">开户支行：</div>
                        <div class="card-info-value">{{form_bank.card_branch || '-'}}</div>
                    </div>
                    <div class="card-info-item">
                        <div class="card-info-label">开户名：</div>
                        <div class="card-info-value">{{form_bank.card_name || '-'}}</div>
                    </div>
                     <div class="card-info-item">
                        <div class="card-info-label">银行卡号：</div>
                        <div class="card-info-value">{{form_bank.card_no || '-'}}</div>
                    </div>
                    
                    <div class="edit-btn" @click="curr_tab = 'bank-edit'">修改</div>
                </div>
            </template>
            <template v-if="curr_tab == 'address'">
                <div class="address-wrapper">
                    <div class="address-tips">
                        <img src="@/assets/images/shop-manage/icon-shop-manage-attention-blue.png" class="tips-icon" />
                        退货地址将展示在买家退货流程中,请确保地址准确无误。
                    </div>
                    <div class="address-item">
                        <div class="address-label">联系人:</div>
                        <Input v-model="form_address.return_name" placeholder="请输入联系人姓名" />
                    </div>
                    <div class="address-item">
                        <div class="address-label">手机号码:</div>
                        <Input v-model="form_address.return_mobile" placeholder="请输入手机号码" />
                    </div>
                    <div class="address-item">
                        <div class="address-label">所在地区:</div>
                        <Cascader :data="region" v-model="region_value" placeholder="请选择省/市/区"></Cascader>
                    </div>
                    <div class="address-item">
                        <div class="address-label">详细地址:</div>
                        <Input v-model="form_address.return_address" placeholder="请输入详细地址" />
                    </div>
                    <div class="save-btn" @click="onInfoUpdate">保存</div>
                </div>
            </template>
            <template v-if="curr_tab == 'refund-setting'">
                <div class="refund-setting-wrapper">
                    <div class="refund-tips">
                        <img src="@/assets/images/shop-manage/icon-shop-manage-attention-blue.png" class="tips-icon" />
                        开启后，买家对店铺「未发货」订单发起「仅退款」申请时将自动退款到账；已发货订单、「退货退款」（需买家寄回商品）与「换货」（不涉及退款）仍由店铺人工审核。
                    </div>
                    <div class="setting-item">
                        <div class="setting-label">退款自动审核：</div>
                        <div class="setting-value">
                            <i-switch v-model="form_refund.is_auto_refund" :true-value="1" :false-value="0" />
                            <span class="setting-status">{{ form_refund.is_auto_refund ? '已开启' : '已关闭' }}</span>
                        </div>
                    </div>
                    <div class="save-btn" @click="onInfoUpdate">保存</div>
                </div>
            </template>
            <template v-if="curr_tab == 'shop-edit'">
                <div class="shop-edit-wrapper">
                    <div class="bread-crumbs">
                        <div class="crumbs-item" @click="curr_tab='info'">店铺信息</div>
                        <Icon type="ios-arrow-forward" class="crumbs-icon" size="14" />
                        <div class="crumbs-item active">编辑</div>
                    </div>
                    <div class="shop-name-item">
                        <div class="item-label">店铺名称</div>
                        <div class="item-value input-wrapper">
                            <Input v-model="form.shop_name" placeholder="请输入店铺名称" />
                        </div>
                    </div>
                    <div class="shop-name-item">
                        <div class="item-label">店铺Logo</div>
                        <div class="item-value upload-wrapper">
                            <div class="img-wrapper">
                                <img :src="form.logo|default_img" alt="" />
                                <img v-if="form.logo" src="@/assets/images/icon-close-circle.png" alt="" @click="form.logo=''" class="del-btn" />
                            </div>
                            <Upload action="/" :data="{ dir: 'template' }" :before-upload="(file)=>onBeforeUpload(file,'logo')">
                                <div class="re-upload-btn">重新上传</div>
                            </Upload>
                        </div>
                    </div>
                    <div class="shop-name-item">
                        <div class="item-label">店铺图片(小程序)</div>
                        <div class="item-value upload-wrapper">
                            <div class="img-wrapper">
                                <img :src="form.shop_image|default_img" alt="" />
                                <img v-if="form.shop_image" src="@/assets/images/icon-close-circle.png" alt="" @click="form.shop_image=''" class="del-btn" />
                            </div>
                            <Upload action="/" :data="{ dir: 'template' }" :before-upload="(file)=>onBeforeUpload(file,'shop_image')">
                                <div class="re-upload-btn">{{ form.shop_image ? '重新上传' :'立即上传' }}</div>
                            </Upload>
                        </div>
                    </div>
                    <div class="shop-name-item">
                        <div class="item-label">
                            店铺图片(PC)
                        </div>
                        <div class="item-value upload-wrapper">
                            <div class="img-wrapper">
                                <img :src="form.shop_banner|default_img" alt="" />
                                <img v-if="form.shop_banner" src="@/assets/images/icon-close-circle.png" alt="" @click="form.shop_banner=''" class="del-btn" />
                                <span class="pic-tips">推荐分辨率:1920*360</span>
                            </div>
                            <Upload action="/" :data="{ dir: 'template' }" :before-upload="(file)=>onBeforeUpload(file,'shop_banner')">
                                <div class="re-upload-btn">{{ form.shop_banner ? '重新上传' : '立即上传' }}</div>
                            </Upload>
                        </div>
                    </div>
                    <div class="shop-name-item tag-align">
                        <div class="item-label">店铺标签</div>
                        <div class="item-value tags-wrapper">
                            <div :class="['tags-item',{active:form.label.includes(item)}]" v-for="(item,index) in label" :key="index" @click="onTagSelect(item)">{{item}}</div>
                            <div class="tag-tips">温馨提示:最多选择3个标签,用于显示店铺名称下方,建议突出店铺的服装风格</div>
                        </div>
                    </div>
                    <div class="shop-name-item tag-align">
                        <div class="item-label">店铺简介</div>
                        <div class="item-value">
                            <Editor dir="shop" v-model="form.shop_desc" :is-clear="true" @change="change_richtext"></Editor>
                            <!-- <div class="text-area-wrapper">
                                <Input v-model="form.shop_desc" placeholder="请输入店铺简介" :maxlength="200" type="textarea" :autosize="{minRows: 6}" />
                                <div class="count-box">
                                    <div class="curr-count">{{ form.shop_desc.length }}</div>
                                    <div class="total-count">/200</div>
                                </div>
                            </div>
                            <div class="tips">温馨提示:简介会展示在店铺首页(不超过200字),简要描述店铺特色、主营产品等</div> -->
                        </div>
                    </div>
                    <div class="btn-box">
                        <div class="btn-cancel" @click="curr_tab = 'info'">取消</div>
                        <div class="btn-save" @click="onInfoUpdate">确认保存</div>
                    </div>
                </div>
            </template>
            <template v-if="curr_tab == 'bank-edit'">
                <div class="bank-edit-wrapper">
                    <div class="bread-crumbs">
                        <div class="crumbs-item" @click="curr_tab='info'">店铺信息</div>
                        <Icon type="ios-arrow-forward" class="crumbs-icon" size="14" />
                        <div class="crumbs-item active">修改绑卡信息</div>
                    </div>
                    <div class="bank-edit-title-desc">
                        <div class="title">绑卡信息</div>
                        <div class="desc">请绑定经营者个人的银行卡,不支持绑定他人银行卡</div>
                    </div>
                    <div class="form">
                        <div class="form-item">
                            <div class="item-label">账户类型</div>
                            <div class="item-value">
                                <RadioGroup v-model="form_bank.card_type">
                                    <Radio :label="1">对私</Radio>
                                    <Radio :label="2">对公</Radio>
                                </RadioGroup>
                            </div>
                        </div>
                        <div class="form-item">
                            <div class="item-label required">开户行</div>
                            <div class="item-value">
                                <Select v-model="form_bank.card_code" filterable @on-change="changeBank" label-in-value>
								    <Option v-for="item in banckList" :value="item.bank_code" :key="item.bank_code">{{ item.bank_name }}</Option>
							    </Select>
                            </div>
                        </div>
                         <div class="form-item">
                            <div class="item-label ">开户地址</div>
                            <div class="item-value">
                               <Cascader class="input1" filterable :data="backArea" v-model="form_bank.bank_area"   placeholder="请选择开户地址"></Cascader>
                            </div>
                        </div>
                        <div class="form-item">
                            <div class="item-label required">开户支行</div>
                            <div class="item-value">
                                <Select v-model="form_bank.branch_code" filterable @on-change="changeBranch" label-in-value>
								    <Option v-for="item in branchList" :value="item.branch_code" :key="item.branch_code">{{ item.branch_name }}</Option>
							    </Select>
                            </div>
                        </div>
                        <div class="form-item">
                            <div class="item-label required">开户名称</div>
                            <div class="item-value">
                                <Input v-model="form_bank.card_name" placeholder="请输入持卡人姓名/对公账户名称" clearable />
                            </div>
                        </div>
                        <div class="form-item">
                            <div class="item-label required">银行卡号</div>
                            <div class="item-value">
                                <Input v-model="form_bank.card_no" type="number" placeholder="请输入银行卡号" clearable />
                            </div>
                        </div>
                        
                        <div class="form-item">
                            <div class="item-label required">手机号码</div>
                            <div class="item-value">
                                <Input v-model="form_bank.card_mobile" placeholder="请输入银行预留手机号码" clearable />
                            </div>
                        </div>
                        <!-- <div class="form-item">
                            <div class="item-label required">地址</div>
                            <div class="item-value">
                                <Input v-model="form_bank.address" placeholder="请输入地址" clearable />
                            </div>
                        </div> -->
                    </div>
                    <div class="btn-box">
                        <div class="btn-cancel" @click="curr_tab = 'info'">取消</div>
                        <div class="btn-save" @click="saveBank">确认修改</div>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>
<script>
import {
    GetBankArea,
    GetBankList,
    GetBranchList,
    getSetting,
    GetUserBank,
    SaveUserBank,
    shopInfoUpdate,
} from '@/api/index';
import Editor from "@/components/WangEditor";
import region from '@/utils/region.js';
import { uploadFileToOSS } from "@/utils/oss";
import { mapState } from 'vuex';
export default{
    name:"ShopInfo",
    components:{
        Editor
    },
    data(){
        return{
            curr_tab:'info',
            region,
            region_value:[],
            form:{
                field:'',
                shop_name:'',
                shop_desc:'',
                label:[],
                logo:'',
                shop_image:'',
                shop_banner:''
            },
            form_address:{},
            // 售后设置：退款自动审核（0关闭 1开启）
            form_refund:{
                is_auto_refund:0
            },
            label:[
                // '女装设计','男装设计','童装设计','原创设计','高级女装','日常百搭','极简主义','小众设计',
                // '质感穿搭','复古文艺','轻奢','独立品牌','量身定做','轻熟气质','复古风','轻熟职场','新中式',
                // '职场通勤','礼服','日常休闲','日常出街','甜酷风','慵懒风','大码服装','高级定制'
            ],
            form_bank:{
                card_type:1,
                card_name:'',
                card_no:'',
                card_bank:'',
                card_branch:'',
                card_mobile:'',
                address:'',
                branch_code:'',
                card_code:'',
                bank_area:[]
            },
            banckList:[],
            branchList:[],
            backArea:[]
            
        }
    },
    watch:{
        curr_tab(news,olds){
            if(news != olds){
                window.scrollTo({
                    top:0,
                    behavior: 'smooth'
                })
            }
        },
        'form_bank.bank_area'(news,olds){
            this.geBranchList()
        },
    },
    computed:{
        ...mapState({
            userInfo:state=>state.userInfo,
            shopInfo:state=>state.shopInfo,
        }),
        idFront(){
            const {image_list,id_card_front} = this.shopInfo;
            if(!image_list && !id_card_front) return '';
            let data;
            if(image_list.length){
                data = image_list.find(item=>{return item.key==="idcard_front"});
            }
            return data?data.value:id_card_front;
        },
        idBack(){
            const {image_list,id_card_back} = this.shopInfo;
            if(!image_list && !id_card_back) return '';
            let data;
            if(image_list.length){
                data = image_list.find(item=>{return item.key==="idcard_back"});
            }
            return data?data.value:id_card_back;
        },
    },
    async mounted(){
        await this.$store.dispatch('getShopInfo');
        console.log('this.shop-info',this.shopInfo);
        const {
            shop_name,
            shop_desc,
            logo,
            label,
            return_address,
            return_mobile,
            return_name,
            return_province,
            return_city,
            return_zone,
            shop_banner,
            shop_image,
            is_auto_refund
        } = this.shopInfo;
        this.form.shop_name = shop_name;
        this.form.shop_desc = shop_desc;
        this.form.logo = logo;
        this.form.label = label;
        this.form.shop_banner = shop_banner;
        this.form.shop_image = shop_image;
        this.form_address = {return_address,return_mobile,return_name};
        this.region_value = [return_province, return_city, return_zone].filter(Boolean);
        this.form_refund = {is_auto_refund: is_auto_refund ? 1 : 0};
       
        getSetting({code:'system',key:'system'}).then(response => {
            console.log('response',response);
            this.label = response.data.shopTag;
        })
        if(this.$route.query.isEdit){
            this.onShopInfoEdit();
        }
        this.getUserBank()
        this.getBankList()
        this.getBankArea()
    },
    methods:{
        async getUserBank(){
            let { data } = await GetUserBank()
            if(data){
                this.form_bank = data
            }
        },
        async getBankArea() {
            let { data } = await GetBankArea()
            this.backArea = data
		},
        async getBankList() {
            let { data } = await GetBankList()
            this.banckList = data
        },
        changeBank(e){
            this.geBranchList(e.value)
            this.form_bank.card_bank = e.label
        },
        async geBranchList(bank_code){
            let param = {
					bank_code:this.form_bank.card_code,
            }
            if(this.form_bank.bank_area){
                param.area_code = this.form_bank.bank_area[1]
            }
            let { data } = await GetBranchList(param)
            this.branchList = data
        },
       changeBranch(e){
            if(e){
                this.form_bank.card_branch = e.label
            }
		},
        async saveBank() {
            if (!this.form_bank.card_name.trim()) {
                return this.$layer.msg('请输入开户名')
            }
            if (!this.form_bank.card_no.trim()) {
                return this.$layer.msg('请输入银行卡号')
            }
            if (!/^\d{16,19}$/.test(this.form_bank.card_no.replace(/\s/g, ''))) {
                return this.$layer.msg('请输入正确的银行卡号')
            }
            if (!this.form_bank.card_mobile.trim()) {
                return this.$layer.msg('请输入手机号码')
            }
            if (!/^1[3-9]\d{9}$/.test(this.form_bank.card_mobile)) {
                return this.$layer.msg('请输入正确的手机号码')
            }
            if (!this.form_bank.card_bank) {
                return this.$layer.msg('请选择开户行')
            }
            if (this.form_bank.bank_area.length == 0) {
                return this.$layer.msg('请选择开户地址')
            }
            if (!this.form_bank.card_branch) {
                return this.$layer.msg('请选择开户支行')
            }
            let { data,code } = await SaveUserBank(this.form_bank)
            this.getUserBank()
            this.$layer.msg(`保存成功`)
        },
        change_richtext(e) {
            this.form.shop_desc = e;
        },
        onBankInfo(){
            //>滚动到id='card'的部分
            this.$nextTick(()=>{
                const el = document.getElementById('card');
                el.scrollIntoView({
                    behavior: 'smooth'
                })
            })
        },
        async onShareClick() {
            const text = `${window.location.origin}/shop/home?uid=${this.userInfo.code}`;
            await navigator.clipboard.writeText(text);
            this.$layer.msg("复制成功~");
        },
        onShopInfoEdit(){
            this.curr_tab = 'shop-edit';
            // this.form.field = 'base';
        },
        async onInfoUpdate(){
            try{
                let form = {};
                switch(this.curr_tab){
                    case 'shop-edit':
                        form = {...this.form,field:'base'};
                        break;
                    case 'bank-edit':
                        form = {...this.form_bank,field:'card'};
                        break;
                    case 'address': {
                        if (this.region_value.length !== 3) {
                            return this.$layer.msg('请选择所在省/市/区');
                        }
                        const [return_province, return_city, return_zone] = this.region_value;
                        form = {
                            ...this.form_address,
                            return_province,
                            return_city,
                            return_zone,
                            field: 'return_address'
                        };
                        break;
                    }
                    case 'refund-setting':
                        form = {...this.form_refund,field:'auto_refund'};
                        break;
                }
                console.log('form',form);
                // return;
                const {code,msg} = await shopInfoUpdate(form);
                if(code>0){
                    this.$layer.msg(msg);
                    return;
                }
                this.$layer.msg('修改成功~');
                if(!['address','refund-setting'].includes(this.curr_tab)){
                    this.curr_tab = 'info';
                }
                this.$store.dispatch('getShopInfo');
                if(this.$route.query.isEdit){
                    const {isEdit,...resetQuery} = this.$route.query;
                    console.log('isEdit',isEdit,'resetQuery',resetQuery);
                    this.$router.replace({query:resetQuery});
                }
            }catch(e){
                console.log('err-info',e);
                this.$layer.msg(e.msg);
            }
        },
        async onBeforeUpload(file,field){
            console.log('field',field);
            const url = await uploadFileToOSS(file, "template");
            this.form[field] = url
            return false;
        },
        onTagSelect(tag){
            if(!this.form.label.includes(tag)){
                if(this.form.label.length >= 3){
                    this.$layer.msg('最多选择3个标签');
                    return;
                }
                this.form.label.push(tag)
            }else{
                this.form.label = this.form.label.filter(item=>item!=tag)
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.shop-info{
    width:100%;
    height:100%;
    background:#fff;
    user-select:none;
    .content-wrapper{
        padding:30px 30px 0px 30px;
        display:flex;
        flex-direction:column;
        .tabs-wrapper{
            width:100%;
            padding-bottom:17px;
            border-bottom:1px solid #d6d6d6;
            display:flex;
            align-items:center;
            column-gap:40px;
            .tab-item{
                color:#666;
                font-size:16px;
                cursor:pointer;
                &.active{
                    color:#1a1a1a;
                    font-size:18px;
                    font-weight:bold;
                    position:relative;
                    &::after{
                        content:'';
                        position:absolute;
                        left:0;
                        bottom:-18px;
                        width:100%;
                        height:2px;
                        background:#ff5967;
                    }
                }
            }
        }
        .info-wrapper{
            width:100%;
            background:#f7faff;
            padding:30px 32px 30px 24px;
            margin-top:20px;
            .info-top{
                width:100%;
                border-bottom:1px solid #dee1e5;
                padding-bottom:18px;
                display:flex;
                justify-content:space-between;
                .top-left{
                    display:flex;
                    column-gap:16px;
                    .shop-logo{
                        width:56px;
                        height:56px;
                        border-radius:4px;
                    }
                    .shop-name-tag{
                        display:flex;
                        flex-direction:column;
                        justify-content:center;
                        row-gap:8px;
                        .shop-name{
                            color:#333;
                            font-size:16px;
                            font-weight:500px;
                        }
                        .shop-tag{
                            color:#666;
                            font-size:12px;
                        }
                    }
                }
                .top-right{
                    display:flex;
                    align-items:center;
                    column-gap:16px;
                    .right-btn{
                        display:flex;
                        align-items:center;
                        justify-content:center;
                        column-gap:4px;
                        padding:8px 12px;
                        border:1px solid #e3e3e3;
                        border-radius:16px;
                        color:#333;
                        font-size:14px;
                        cursor:pointer;
                        .btn-icon{
                            width:16px;
                            height:16px;
                        }

                        &.edit{
                            padding:8px 26px;
                            border:1px solid #0d99ff;
                            color:#0d99ff;
                        }
                    }
                }
            }
            .info-desc{
                display:flex;
                column-gap:8px;
                color:#666;
                font-size:14px;
                margin-top:16px;
                .label{
                    flex-shrink:0;
                }
                .desc{
                    width:100%;
                    max-width:755px;
                    white-space:pre-wrap;
                }
            }
        }
        .part-title{
            color:#333;
            font-weight:bold;
            font-size:18px;
            margin-top:40px;
        }

        .shop-type-part{
            display:flex;
            column-gap:60px;
            align-items:center;
            margin-top:24px;
            width:100%;
            .shop-type-item{
                display:flex;
                align-items:center;
                font-size:14px;
                .label{
                    color:#666;
                }
                .value{
                    color:#333;
                }
            }
        }
        .shop-certificate-part{
            display:flex;
            align-items:center;
            column-gap:30px;
            margin-top:40px;
            .part-item{
                display:flex;
                flex-direction:column;
                justify-content:center;
                row-gap:24px;
                .part-label{
                    color:#666;
                    font-size:14px;
                }
                .part-value{
                    width:280px;
                    height:188px;
                    border-radius:10px;
                }
            }
            .change-btn{
                width:80px;
                height:32px;
                line-height:32px;
                border-radius:4px;
                border:1px solid #0d99ff;
                text-align:center;
                font-size:14px;
                color:#0d99ff;
                margin-left:36px;
                margin-top: 30px;
                cursor: pointer;
            }
        }
        .card-info{
            display:flex;
            flex-direction:column;
            margin-top:24px;
            row-gap:24px;
            .card-info-item{
                display:flex;
                align-items:center;
                font-size:14px;
                .card-info-label{
                    color:#666;
                    width:70px;
                }
                .card-info-value{
                    color:#333;
                }
            }
            .edit-btn{
                margin-top:40px;
                margin-bottom:100px;
                width:80px;
                height:32px;
                text-align:center;
                line-height:32px;
                cursor:pointer;
                color:#0d99ff;
                font-size:14px;
                border:1px solid #0d99ff;
                border-radius:4px;
            }
        }
        .address-wrapper{
            width:100%;
            display:flex;
            flex-direction:column;
            row-gap:20px;
            margin-top:30px;
            .address-tips{
                background:#f7faff;
                padding:30px 16px;
                display:flex;
                align-items:center;
                column-gap:8px;
                color:#666;
                font-size:14px;
                .tips-icon{
                    width:20px;
                    height:20px;
                }
            }
            .address-item{
                width:30%;
                display:flex;
                flex-direction:column;
                row-gap:10px;
                .address-label{
                    color:#333;
                    font-size:14px;
                    font-weight:500;
                }
            }
            .save-btn{
                width:80px;
                height:32px;
                line-height:32px;
                text-align:center;
                font-size:14px;
                color:#fff;
                background:#ff5967;
                border-radius:4px;
                cursor:pointer;
                margin-top:20px;
                margin-bottom:50px;
            }
        }
        .refund-setting-wrapper{
            width:100%;
            display:flex;
            flex-direction:column;
            row-gap:20px;
            margin-top:30px;
            .refund-tips{
                background:#f7faff;
                padding:30px 16px;
                display:flex;
                align-items:flex-start;
                column-gap:8px;
                color:#666;
                font-size:14px;
                line-height:22px;
                .tips-icon{
                    width:20px;
                    height:20px;
                    flex-shrink:0;
                }
            }
            .setting-item{
                display:flex;
                align-items:center;
                column-gap:10px;
                .setting-label{
                    color:#333;
                    font-size:14px;
                    font-weight:500;
                }
                .setting-value{
                    display:flex;
                    align-items:center;
                    column-gap:10px;
                    .setting-status{
                        color:#666;
                        font-size:14px;
                    }
                }
            }
            .save-btn{
                width:80px;
                height:32px;
                line-height:32px;
                text-align:center;
                font-size:14px;
                color:#fff;
                background:#ff5967;
                border-radius:4px;
                cursor:pointer;
                margin-top:20px;
                margin-bottom:50px;
            }
        }
        .shop-edit-wrapper{
            width:100%;
            display:flex;
            flex-direction:column;
            row-gap:42px;
            .shop-name-item{
                display:flex;
                column-gap:16px;
                align-items:center;
                &.tag-align{
                    align-items:flex-start;
                }
            }
            .item-label{
                color:#333;
                font-size:14px;
                flex-shrink:0;
                // display:flex;
                // flex-direction:column;
                span{
                    color:#666;
                    font-size:12px;
                }
                &::after{
                    content:"*";
                    color:red;
                }
            }
            .item-value{
                flex:1;
                &.input-wrapper{
                    max-width:750px;
                }
                &.upload-wrapper{
                    display:flex;
                    align-items:center;
                    column-gap:16px;
                    .img-wrapper{
                        width:80px;
                        height:80px;
                        border-radius:4px;
                        position:relative;
                        img{
                            width:100%;
                            height:100%;
                            border-radius:4px;
                        }
                        .del-btn{
                            position:absolute;
                            top:0;
                            right:0;
                            width:20px;
                            height:20px;
                            cursor:pointer;
                        }
                        .pic-tips{
                            color:#666;
                            font-size:12px;
                            position:absolute;
                            bottom:-20px;
                            left:0;
                            white-space:nowrap;
                        }
                    }
                    .re-upload-btn{
                        color:#0d99ff;
                        font-size:12px;
                        cursor:pointer;
                    }
                }
                &.tags-wrapper{
                    display:flex;
                    column-gap:8px;
                    row-gap:12px;
                    flex-wrap:wrap;
                    max-width:calc(748px + 327px + 84px);
                    .tags-item{
                        color:#333;
                        padding:5px 14px;
                        background:#f5f5f5;
                        border-radius:16px;
                        cursor:pointer;
                        &:hover, &.active{
                            color:#fff;
                            background:#ff5967;
                        }
                    }
                    .tag-tips{
                        width:100%;
                        color:#999;
                        font-size:14px;
                    }
                }
                .text-area-wrapper{
                    max-width:748px;
                    height:150px;
                    position:relative;
                    ::v-deep .textarea-wrapper{
                        width:100%;
                        height:100%;
                    }
                    ::v-deep .ivu-input-wrapper{
                        width:100%;
                        height:100%;
                        textarea{
                            width:100%;
                            height:100%;
                            resize: none;
                        }
                    }
                    .count-box{
                        position:absolute;
                        bottom:15px;
                        right:10px;
                        font-size:14px;
                        display:flex;
                        align-items:center;
                        .curr-count{
                            color:#333;
                        }
                        .total-count{
                            color:#999;
                        }
                    }
                }
                .tips{
                    width:100%;
                    color:#999;
                    font-size:14px;
                    margin-top:16px;
                }
            }
            .btn-box{
                display:flex;
                align-items:center;
                column-gap:10px;
                margin-left:76px;
                padding-bottom:50px;
                .btn-cancel{
                    width:100px;
                    height:40px;
                    line-height:40px;
                    text-align:center;
                    border:1px solid #e3e3e3;
                    border-radius:4px;
                    cursor:pointer;
                    color:#666;
                    font-weight:bold;
                    font-size:14px;
                }
                .btn-save{
                    width:120px;
                    height:40px;
                    line-height:40px;
                    text-align:center;
                    background:#ff5967;
                    border-radius:4px;
                    color:#fff;
                    font-weight:bold;
                    font-size:14px;
                    cursor:pointer;
                }
            }
        }

        .btn-box{
            display:flex;
            align-items:center;
            column-gap:10px;
            margin-left:76px;
            margin-top:50px;
            .btn-cancel{
                width:100px;
                height:40px;
                line-height:40px;
                text-align:center;
                border:1px solid #e3e3e3;
                border-radius:4px;
                cursor:pointer;
                color:#666;
                font-weight:bold;
                font-size:14px;
            }
            .btn-save{
                width:120px;
                height:40px;
                line-height:40px;
                text-align:center;
                background:rgb(255, 89, 103);
                border-radius:4px;
                color:#fff;
                font-weight:bold;
                font-size:14px;
                cursor:pointer;
            }
        }
        .bank-edit-wrapper{
            width:100%;
            display:flex;
            flex-direction:column;
            margin-bottom:244px;
            .bank-edit-title-desc{
                width:100%;
                display:flex;
                flex-direction:column;
                row-gap:6px;
                margin-top:32px;
                .title{
                    color:#333;
                    font-weight:bold;
                    font-size:18px;
                }
                .desc{
                    color:#999;
                    font-size:14px;
                }
            }
            .form{
                display:flex;
                flex-direction:column;
                row-gap:32px;
                margin-top:32px;
                .form-item{
                    display:flex;
                    align-items:center;
                    column-gap:16px;
                    .item-label{
                        color:#333;
                        font-size:14px;
                        width:63px;
                        &.required::after{
                            content:"*";
                            color:red;
                        }
                    }
                    .item-value{
                        width:100%;
                        max-width:679px;
                    }
                }
            }
        }
        .bread-crumbs{
            display:flex;
            align-items:center;
            column-gap:8px;
            padding-bottom:22px;
            border-bottom:1px solid #d6d6d6;
            .crumbs-item{
                color:#999;
                font-size:14px;
                cursor:pointer;
                &:hover, &.active{
                    color:#333;
                }
            }
        }
    }
}

::v-deep .ivu-radio-focus {
    -webkit-box-shadow: 0 0 0 2px rgba(255, 89, 103, .2);
    box-shadow: 0 0 0 2px rgba(255, 89, 103, .2);
    z-index: 1;
    &::after{
        background-color:#ff5967;
    }
}
::v-deep .ivu-radio-checked .ivu-radio-inner {
    border-color: #ff5967;
    &::after{
        background-color:#ff5967;
    }
}
</style>
